export default $api => {
  $api.register('social-fund-api', '/web/private/client', request => ({
    requestOtpCode() {
      return request('POST', '/social-fund/otp-code/request');
    },
    confirmSocialFundConsent(payload) {
      return request('POST', '/social-fund/otp-code/verify', payload);
    },
    checkSocialFundStatus() {
      return request('GET', '/social-fund/otp-code/check');
    },
  }));
};
